"use strict";

var _regeneratorRuntime = require("/home/fabienjuif/work/k-mille2/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _kRamel = require("k-ramel");

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
  try {
    var info = gen[key](arg);
    var value = info.value;
  } catch (error) {
    reject(error);
    return;
  }

  if (info.done) {
    resolve(value);
  } else {
    Promise.resolve(value).then(_next, _throw);
  }
}

function _asyncToGenerator(fn) {
  return function () {
    var self = this,
        args = arguments;
    return new Promise(function (resolve, reject) {
      var gen = fn.apply(self, args);

      function _next(value) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
      }

      function _throw(err) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
      }

      _next(undefined);
    });
  };
}

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

var resetAuth = function resetAuth(action, store, _ref) {
  var router = _ref.router,
      graphql = _ref.graphql;
  if (router.getCurrentCode() !== 'login') return;

  try {
    window.localStorage.removeItem('auth');
  } catch (ex) {
    /* ignore error */
  }

  graphql.mutation('{ disconnect }');
};

var getAuth = function getAuth(action, store) {
  var auth;

  try {
    auth = JSON.parse(window.localStorage.getItem('auth') || {});
  } catch (ex) {
    /* ignore error */
  }

  if (auth && auth.roles) {
    store.dispatch({
      type: '@@AUTH>FOUND',
      payload: auth
    });
  }
};

var setProject = function setProject(action, store, _ref2) {
  var router = _ref2.router;
  if (router.getCurrentCode() !== 'login') return;
  var project;

  try {
    project = JSON.parse(window.localStorage.getItem('project') || {});
  } catch (ex) {
    /* ignore error */
  }

  if (project && project.code) {
    var oldProject = store.data.profile.project.get();

    if (!oldProject || oldProject.code !== project.code) {
      store.data.profile.project.set(project);
    }
  }
};

var setProfile = function setProfile(_ref3, store) {
  var payload = _ref3.payload;

  var roles = payload.roles,
      project = payload.project,
      projects = payload.projects,
      token = payload.token,
      info = _objectWithoutProperties(payload, ["roles", "project", "projects", "token"]);

  var innerProject = project || projects[0];
  window.localStorage.setItem('auth', JSON.stringify(_objectSpread({
    roles: roles,
    projects: projects
  }, info)));
  window.localStorage.setItem('project', JSON.stringify(innerProject));
  store.data.profile.roles.set(roles);
  store.data.profile.info.set(info);
  store.data.profile.project.set(innerProject);
};

var getProfile =
/*#__PURE__*/
function () {
  var _ref5 = _asyncToGenerator(
  /*#__PURE__*/
  _regeneratorRuntime.mark(function _callee(action, store, _ref4) {
    var router, graphql, _ref6, data;

    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            router = _ref4.router, graphql = _ref4.graphql;

            if (!(router.getCurrentCode() === 'login')) {
              _context.next = 3;
              break;
            }

            return _context.abrupt("return");

          case 3:
            if (!store.data.profile.info.isInitialized()) {
              _context.next = 5;
              break;
            }

            return _context.abrupt("return");

          case 5:
            _context.next = 7;
            return graphql.query("{\n    me {\n      email\n      name\n      firstName\n      roles\n      projects {\n        code\n        name\n        parameters {\n          primaryColor\n          secondaryColor\n        }\n      }\n    }\n  }");

          case 7:
            _ref6 = _context.sent;
            data = _ref6.data;

            if (data && data.me) {
              store.dispatch({
                type: '@@AUTH>FOUND',
                payload: data.me
              });
            }

          case 10:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));

  return function getProfile(_x, _x2, _x3) {
    return _ref5.apply(this, arguments);
  };
}();

var redirectToLogin = function redirectToLogin(action, store, _ref7) {
  var router = _ref7.router;
  if (router.getCurrentCode() === 'login') return;
  router.push('login');
};

var _default = {
  getReducer: function getReducer() {
    return {
      path: 'data.profile',
      reducer: {
        info: _kRamel.types.object(),
        roles: _kRamel.types.array(),
        project: _kRamel.types.object()
      }
    };
  },
  getDriver: function getDriver(store) {
    store.listeners.add([(0, _kRamel.when)('@@router/ROUTE_FOUND')(resetAuth), (0, _kRamel.when)('@@router/ROUTE_FOUND')(getProfile), (0, _kRamel.when)('@@router/ROUTE_FOUND')(getAuth), (0, _kRamel.when)('@@router/ROUTE_FOUND')(setProject), (0, _kRamel.when)('@@AUTH>FOUND')(setProfile), (0, _kRamel.when)('@@graphql/me>FAILED')(redirectToLogin)]);
    return {
      logout: function logout() {
        store.reset();
        store.drivers.router.push('login');
      },
      getRoles: function getRoles() {
        return console.log('TODO: getRoles');
      }
    };
  }
};
exports["default"] = _default;